import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { 
  LayoutDashboard, 
  Calendar, 
  Calculator, 
  Users, 
  FolderOpen, 
  FileText,
  Receipt,
  MessageSquare,
  Mail,
  FileCode,
  Bot,
  ClipboardList,
  Scale
} from 'lucide-react';
import { cn } from '../../lib/utils';

const menuItems = [
  { icon: LayoutDashboard, label: 'Panel', path: '/panel' },
  { icon: Calendar, label: 'Calendario', path: '/calendario' },
  { icon: Users, label: 'Contactos', path: '/contactos' },
  { icon: FolderOpen, label: 'Expedientes', path: '/expedientes' },
  { icon: Scale, label: 'Sentencias', path: '/sentencias' },
  { icon: ClipboardList, label: 'Tareas', path: '/tareas' },
  { icon: Bot, label: 'Asistente IA', path: '/chat' },
  { icon: FileText, label: 'Informes', path: '/informes' },
  { icon: MessageSquare, label: 'Comunicaciones', path: '/comunicaciones' },
  { icon: Receipt, label: 'Contabilidad', path: '/contabilidad' },
  { icon: Mail, label: 'Correo', path: '/correo' },
  { icon: FileCode, label: 'Plantillas', path: '/plantillas' },
  { icon: Calculator, label: 'Calculadoras', path: '/calculadora' }
];

const TopNavigation = () => {
  const location = useLocation();

  return (
    <nav className="bg-white border-b border-gray-200">
      <div className="flex items-center overflow-x-auto">
        {menuItems.map((item) => {
          const Icon = item.icon;
          const isActive = location.pathname === item.path || 
                          (item.path !== '/panel' && location.pathname.startsWith(item.path));
          
          return (
            <Link
              key={item.path}
              to={item.path}
              className={cn(
                "flex items-center gap-2 px-4 py-3 text-sm font-medium whitespace-nowrap border-b-2 transition-all duration-200 hover:text-blue-700 hover:border-blue-300",
                isActive 
                  ? "text-blue-700 border-blue-600" 
                  : "text-gray-600 border-transparent"
              )}
            >
              <Icon className="w-4 h-4" />
              <span>{item.label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
};

export default TopNavigation;
